module.exports = __webpack_public_path__ + "img/icono_candado_desbloqueado.1c158b03.svg";